// console.log(productVariants);
// console.log(allProductImages);

class VariantGallery {
  constructor() {
    this.mainSwiper = null;
    this.modalMainSwiper = null;
    this.thumbsSwiper = null;
    this.modalThumbsSwiper = null;
    this.currentVariantId = null;
    this.init();
  }

  init() {
    this.loadFirstVariant();
  }

  loadFirstVariant() {
    let firstVariantId = productVariants[0].id;
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (variantId) {
      firstVariantId = variantId;
    }

    if (firstVariantId) {
      this.switchVariant(firstVariantId);
    }
  }

  switchVariant(variantId, target = false) {
    if (target && target.closest('.quick-add-modal')) return;
    if (this.currentVariantId === variantId) return;

    this.currentVariantId = variantId;

    let variantData = window.productVariants.find((v) => v.id == variantId);

    if (!variantData || !variantData.images.length) {
      console.warn(`No images found for variantId: ${variantId}`);
      variantData = {};
      variantData.images = allProductImages;
    }

    this.updateGalleries(variantData.images);
  }

  updateGalleries(images) {
    if (this.mainSwiper) this.mainSwiper.destroy(true, true);
    if (this.modalMainSwiper) this.modalMainSwiper.destroy(true, true);
    if (this.thumbsSwiper) this.thumbsSwiper.destroy(true, true);
    if (this.modalThumbsSwiper) this.modalThumbsSwiper.destroy(true, true);
    this.updateMainGallery(images);
    this.updateThumbsGallery(images);
    this.initSwipers();
  }

  updateMainGallery(images) {
    const mainGallery = document.getElementById('main-gallery').querySelector('.swiper-wrapper');
    const modalMainGallery = document.getElementById('modal-main-gallery').querySelector('.swiper-wrapper');
    let lazyAttr = ``;
    const mainGalleryImages = images
      .map((image, index) => {
        const slide = `
          <button class="swiper-slide reset__btn" onclick="openDialog('gallery-modal',this)" data-index="${index}">
            <img src="${image.src}" alt="${image.alt}" ${lazyAttr} style="object-position: ${image.focal}">
          </button>
        `;
        lazyAttr = `loading="lazy"`;
        return slide;
      })
      .join('');
    mainGallery.innerHTML = mainGalleryImages;
    mainGallery.querySelectorAll('.swiper-slide img').forEach((img) => {
      img.addEventListener('load', () => {
        img.parentElement.classList.add('loaded');
      });
    });

    const modalGalleryImages = images
      .map((image) => {
        const slide = `
          <div class="swiper-slide">
            <img src="${image.large}" alt="${image.alt}" ${lazyAttr} style="object-position: ${image.focal}">
          </div>
        `;
        lazyAttr = `loading="lazy"`;
        return slide;
      })
      .join('');
    modalMainGallery.innerHTML = modalGalleryImages;
    modalMainGallery.querySelectorAll('.swiper-slide img').forEach((img) => {
      img.addEventListener('load', () => {
        img.parentElement.classList.add('loaded');
      });
    });
  }

  updateThumbsGallery(images) {
    const thumbsGallery = document.getElementById('thumbs-gallery').querySelector('.swiper-wrapper');
    const modalThumbsGallery = document.getElementById('modal-thumbs-gallery').querySelector('.swiper-wrapper');
    const imagesList = images
      .map(
        (image) => `
          <div class="swiper-slide">
              <img src="${image.thumb}" alt="${image.alt}" style="object-position: ${image.focal}">
          </div>
        `
      )
      .join('');

    thumbsGallery.innerHTML = imagesList;
    modalThumbsGallery.innerHTML = imagesList;
  }

  initSwipers() {
    const thumbsGallery = document.getElementById('thumbs-gallery');
    const mainGallery = document.getElementById('main-gallery');
    this.thumbsSwiper = new Swiper(thumbsGallery, {
      spaceBetween: 2,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      direction: 'horizontal',
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1024: {
          direction: 'vertical',
        },
      },
    });
    this.mainSwiper = new Swiper(mainGallery, {
      spaceBetween: 0,
      slidesPerView: 1,
      speed: 1200,
      mousewheel: {
        forceToAxis: true,
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
    });

    const modalThumbsGallery = document.getElementById('modal-thumbs-gallery');
    const modalMainGallery = document.getElementById('modal-main-gallery');
    this.modalThumbsSwiper = new Swiper(modalThumbsGallery, {
      spaceBetween: 2,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
      },
    });
    this.modalMainSwiper = new Swiper(modalMainGallery, {
      spaceBetween: 0,
      slidesPerView: 1,
      speed: 1200,
      mousewheel: {
        forceToAxis: true,
      },
      thumbs: {
        swiper: this.modalThumbsSwiper,
      },
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const variantGalleryInstance = new VariantGallery();
  window.updateVariantGallery = variantGalleryInstance.switchVariant.bind(variantGalleryInstance);
});
